(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["longeva-footer-premium"] && !Shopify.designMode) return;
  try {
    
  // On mobile (<750px), close all nav details by default.
  // On desktop, CSS forces them open via display:block on panel children.
  (function() {
    var mq = window.matchMedia('(max-width: 749px)');
    function initFooterDisclosures() {
      if (mq.matches) {
        document.querySelectorAll('.longeva-footer__nav-details').forEach(function(d) {
          d.removeAttribute('open');
        });
      } else {
        document.querySelectorAll('.longeva-footer__nav-details').forEach(function(d) {
          d.setAttribute('open', '');
        });
      }
    }
    initFooterDisclosures();
    mq.addEventListener('change', initFooterDisclosures);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
